import { useLanguage } from "@/context/LanguageContext";
import { C, COMPANY } from "@/data/content";
import { scrollToId } from "@/utils/scroll";
import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";

const LINKS = [
    ["home", C.nav.home],
    ["about", C.nav.about],
    ["services", C.nav.services],
    ["compare", C.nav.compare],
    ["process", C.nav.process],
    ["markets", C.nav.markets],
    ["why-us", C.nav.whyus],
    ["contact", C.nav.contact],
];

export default function Footer() {
    const { L } = useLanguage();
    const navigate = useNavigate();

    return (
        <footer className="border-t border-gold-line/50 bg-ink">
            <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:grid-cols-2 md:grid-cols-4">
                <div className="sm:col-span-2 md:col-span-1">
                    <Logo />
                    <p className="mt-5 text-sm leading-relaxed text-txt-2">
                        {L(COMPANY.name)} — {L(C.footer.tagline)}
                    </p>
                    <p className="font-mono-x mt-4 text-[11px] tracking-[0.2em] text-txt-3">
                        {COMPANY.brand}
                    </p>
                </div>

                <div>
                    <p className="font-mono-x text-[11px] tracking-[0.3em] text-brass uppercase">
                        {L(C.footer.servicesTitle)}
                    </p>
                    <ul className="mt-5 space-y-2.5">
                        {C.services.items.map((s) => (
                            <li key={s.id}>
                                <button
                                    data-testid={`footer-service-${s.id}`}
                                    onClick={() => scrollToId("services")}
                                    className="text-start text-xs leading-relaxed text-txt-2 transition-colors hover:text-brass"
                                >
                                    {L(s.title)}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="font-mono-x text-[11px] tracking-[0.3em] text-brass uppercase">
                        {L(C.footer.linksTitle)}
                    </p>
                    <ul className="mt-5 space-y-3">
                        {LINKS.map(([id, label]) => (
                            <li key={id}>
                                <button
                                    data-testid={`footer-link-${id}`}
                                    onClick={() => scrollToId(id)}
                                    className="text-sm text-txt-2 transition-colors hover:text-brass"
                                >
                                    {L(label)}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="font-mono-x text-[11px] tracking-[0.3em] text-brass uppercase">
                        {L(C.footer.contactTitle)}
                    </p>
                    <ul className="mt-5 space-y-3 text-sm">
                        {COMPANY.phones.map((p, i) => (
                            <li key={p.href} data-testid={`footer-phone-${i + 1}`} dir="ltr">
                                {p.display}
                            </li>
                        ))}
                        <li data-testid="footer-email" dir="ltr">
                            {COMPANY.email}
                        </li>
                        <li dir="auto" data-testid="footer-address">
                            {L(COMPANY.address)}
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-gold-line/30 py-6 text-center">
                <p className="text-sm text-txt-2">
                    © 2026 {L(COMPANY.name)} — {L(C.footer.rights)}
                </p>
                <p className="font-mono-x mt-2 text-[10px] tracking-[0.3em] text-txt-3">
                    {COMPANY.brand.toUpperCase()} · GUANGZHOU · CHINA — {COMPANY.coords}
                </p>
                <button
                    onClick={() => navigate("/admin")}
                    data-testid="footer-admin-link"
                    className="font-mono-x mt-3 text-[10px] tracking-[0.2em] text-txt-3 transition-colors hover:text-brass"
                >
                    ADMIN
                </button>
            </div>
        </footer>
    );
}
